/**
 * Creates a centred page-width container aligned with **`ux/common/visual-foundations`** max width.
 *
 * @returns A **`div`** with **`qz-page`** class; append children for route content.
 */
export function createPageContainer(): HTMLDivElement {
  const el = document.createElement("div");
  el.className = "qz-page";
  return el;
}
